/**
 * @generated SignedSource<<e48c3502bc915f05dc30329996e164db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InputFilterGroupGroup_tenant$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"InputFilterGroup_tenant">;
  readonly " $fragmentType": "InputFilterGroupGroup_tenant";
};
export type InputFilterGroupGroup_tenant$key = {
  readonly " $data"?: InputFilterGroupGroup_tenant$data;
  readonly " $fragmentSpreads": FragmentRefs<"InputFilterGroupGroup_tenant">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InputFilterGroupGroup_tenant",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InputFilterGroup_tenant"
    }
  ],
  "type": "TenantNode",
  "abstractKey": null
};

(node as any).hash = "9f8ce72c80a4383b06d0458ca6e9979c";

export default node;
